import {Adapter} from "./adapter";
import {nextFrame} from "../Utils";

export default class InlineAdapter extends Adapter {
    setup() {
        this._currentIndex = 0;
        this.dialog.items.forEach(item => {
            this._elements.push($(item.src));
        });
    }

    /**
     * @param index {number}
     * @returns {AdapterItem}
     */
    getForIndex(index) {
        const $element = this._elements[index];
        return {
            $el: $element,
            src: '',
            title: '',
            ready: () => {
                return new Promise(resolve => {
                    (async () => {
                        await nextFrame();
                        resolve($element[0]);
                    })();
                });
            }
        }
    }

}
